import Vuex from "vuex";
import Vue from "vue";
import filters from "./modules/filters";
import pager from "./modules/pager";
import request from "./modules/request";
import offer from "./modules/offer";
import seminar from "./modules/seminar";
import customer from "./modules/customer";
import company from "./modules/company";
import contact from "./modules/contact";
import trainer from "./modules/trainer";
import employee from "./modules/employee";
import offerType from "./modules/offer-type";
import hashParams from "./modules/hash-params";
import rating from "./modules/rating";
import sales from "./modules/sales";
import user from "./modules/user";
import offerLog from "./modules/offer-log";
import selectedTab from "./modules/selected-tab";
import proxy from "./modules/proxy";
import seminarDate from "./modules/seminarDate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    filters,
    pager,
    request,
    offer,
    offerLog,
    seminar,
    customer,
    company,
    contact,
    trainer,
    employee,
    offerType,
    hashParams,
    rating,
    sales,
    user,
    selectedTab,
    proxy,
    seminarDate,
  },
});
